var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center font-weight-bold w-100"
  }, [_c('div', {
    staticClass: "icon-item--rounded"
  }, [_c('div', {
    staticClass: "icon-item--rounded__inner d-flex flex-column align-center justify-center",
    style: 'background-color:' + _vm.bgColor + ';'
  }, [_c('v-img', {
    attrs: {
      "src": _vm.icon,
      "contain": "",
      "max-height": "52"
    }
  }), _vm.tit ? _c('p', {
    staticClass: "page-text--sm line-height-1 color-white mt-6 mt-lg-12"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]) : _vm._e()], 1)]), _vm.sc ? _c('p', {
    staticClass: "page-text color-grey mt-8 mt-lg-14"
  }, [_vm._v(" " + _vm._s(_vm.sc) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }